import React from 'react';
import { Text, TextProps } from '@chakra-ui/react';

interface TableTextProps extends Omit<TextProps, 'children'> {
  children: React.ReactNode;
  variant?: 'id' | 'primary' | 'default';
}

const TableText: React.FC<TableTextProps> = ({ 
  children,
  variant = 'default',
  ...textProps 
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'id':
        return {
          fontSize: 'sm',
          color: 'gray.500',
        };
      case 'primary':
        return {
          fontSize: 'sm',
          fontWeight: 'medium',
          color: 'gray.900',
          _dark: { color: 'gray.100' },
        };
      case 'default':
      default:
        return {
          fontSize: 'sm',
        };
    }
  };

  return (
    <Text 
      {...getVariantStyles()}
      wordBreak="break-word"
      lineHeight="1.5"
      {...textProps}
    >
      {children}
    </Text>
  );
};

export default TableText; 